import React from 'react';
import Dropdown, {DropdownItem} from "components/Dropdown";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import {Zone} from 'types/Zone';
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";

// Types ----

type ZoneContextMenuProps = {
  zone: Zone
  onDeleteZone: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function ZoneContextMenu({zone, onDeleteZone, viewDisabled, editDisabled, deleteDisabled, position = 'right'}: ZoneContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewZone() {
    void navigate(`/zones/${zone.id}`)
  }

  function editZone() {
    void navigate(`/zones/${zone.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('zones:read') &&
        <DropdownItem name="View" icon={EyeIcon} onClick={viewZone} disabled={!!viewDisabled}/>
      }

      {auth.can('zones:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editZone} disabled={!!editDisabled}/>
      }

      {auth.can('zones:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteZone} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default ZoneContextMenu;